import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	// TODO: [JSC-2233] remove nonfinal suffix after confirming with CD
	noLabel: {
		id: 'issue-table-grouping.group-row.group-header.label-group-header.no-label-nonfinal',
		defaultMessage: 'Unlabelled',
		description: 'Label for grouped items without label',
	},
});
